import script from "./UserCountrySelector.vue?vue&type=script&lang=js"
export * from "./UserCountrySelector.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__